import React from 'react';

import './Modal.css';

function ModalWrapper(props) {
  // Strings are passed through as-is; Modal sanitizes and renders them (CH-3389).
  function openModal() {
    props.onOpenModal(props.modalText);
  }

  return (
    <>
      {props.modalText && (
        <span onClick={openModal} className="modal_wrapper">
          {props.children}
        </span>
      )}
      {!props.modalText && props.children}
    </>
  );
}
export default ModalWrapper;
